import { Column } from '@synqo/frontend-component-library';
import { ApiCostBearer } from '@Model';

export const costBearerColumns: Column<ApiCostBearer>[] = [
    { name: 'shorthand', label: 'Suchcode' },
    { name: 'number', label: 'Nummer' },
    { name: 'label', label: 'Bezeichnung' },
];
